/**
 * CookieNotice — small bottom notice about cookies in the portal (14 Oct 2026).
 * The portal uses only necessary cookies / browser storage (sign-in, Stripe payments, reCAPTCHA spam protection);
 * no analytics or advertising cookies, so no consent choice is needed — just information with a link to the policy.
 * Shown until the visitor clicks OK (remembered in this browser).
 */
import React, { useEffect, useState } from 'react';

const KEY = 'ctCookieNoticeOk';

export default function CookieNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    let seen = false;
    try { seen = window.localStorage.getItem(KEY) === '1'; } catch (e) { /* storage blocked: show it */ }
    setShow(!seen);
  }, []);
  if (!show) return null;
  const ok = () => {
    try { window.localStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
    setShow(false);
  };
  return (
    <div role="region" aria-label="Cookie notice"
      style={{ position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 9999, maxWidth: 760, margin: '0 auto',
        background: '#0f2537', color: '#e8f1f8', border: '1px solid #23405a', borderRadius: 12,
        padding: '12px 14px', boxShadow: '0 6px 24px rgba(0,0,0,0.35)', fontSize: 14, lineHeight: 1.45,
        display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
      <span style={{ flex: '1 1 320px' }}>
        This portal uses only necessary cookies and browser storage — to keep you signed in, process payments
        (Stripe) and protect forms from spam (Google reCAPTCHA). No advertising or tracking cookies.{' '}
        <a href="https://cetalingua.com/privacy-policy/" target="_blank" rel="noopener noreferrer"
          style={{ color: '#4fc3f7' }}>Privacy Policy</a>
      </span>
      <button type="button" onClick={ok}
        style={{ padding: '8px 18px', borderRadius: 8, border: 'none', background: '#1e88e5', color: '#fff',
          fontSize: 14, cursor: 'pointer' }}>OK</button>
    </div>
  );
}
